
































































import {
    defineComponent,
    PropType,
    watch,
    computed
} from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
export default defineComponent({
    components: {
        PairToggle: () =>
            import(/*webpackChunkName: "components"*/ "../PairToggle.vue")
    },
    props: {
        imgSrc: { type: String, required: true },
        connected: { type: Boolean, default: false },
        value: Object as PropType<AttachedDeviceModel>
    },
    setup(props, context) {
        const status = computed(() => {
            if (props.value) {
                return props.value.attachedDeviceId
                    ? props.value.attachedDeviceId !== ""
                    : false;
            } else {
                return false;
            }
        });
        const responsive = computed<boolean>(() => {
            if (props.value.attachedDeviceId != null) {
                if (props.value.age <= 1) {
                    return true;
                } else {
                    return false;
                }
            }
        });

        const battery = computed(() => {
            return props.value ? !props.value.batteryLow : false;
        });
        watch(
            () => props.value,
            newValue => {
                if (newValue) {
                    console.log(newValue.batteryLow);
                }
            }
        );
        const toggleConnect = () => {
            context.emit("enroll", props.value);
        };
        return {
            toggleConnect,
            status,
            battery,
            responsive
        };
    }
});
